<template>
    <div id="canvas-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                icon="arrow-left"
                :action="() => $router.push('/canvasoverview')"
                :label="trans('pages.canvas_page.to_overview')"
            />
            <actions-menu-item
                :v4="true"
                icon="pencil"
                :action="() => $router.push('/editcanvaspage/' + idParam)"
                :label="trans('pages.canvas_page.edit')"
            />
            <actions-menu-item
                :v4="true"
                :action="removeCanvas"
                class="alert"
                icon="trash-o"
                :label="trans('pages.canvas_page.delete')"
            />
        </actions-menu>

        <spinner-text v-if="loading || !canvas">
            {{ trans('pages.canvas_page.loading') }}
        </spinner-text>
        <template v-else>
            <div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.canvas_number') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.code }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.canvas_type') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.type }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.color') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.color }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.manufacturer_code') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ canvas.codeManufacturer }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.manufacturer') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ canvas.manufacturer }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.description') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.description }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.notes') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.notes }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.default_canvas') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            canvas.defaultCanvas
                                ? trans('pages.canvas_page.yes')
                                : trans('pages.canvas_page.no')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.canvas_page.sort') }}
                    </div>
                    <div class="profilepagevalue">{{ canvas.sort }}</div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import canvasApi from '../api/canvas';
import SpinnerText from '../components/loader/SpinnerText';
import IdParamMixin from '../mixins/id-param';
import OutputHelper from '../helpers/OutputHelper';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: { SpinnerText, ActionsMenu, ActionsMenuItem },
    computed: {
        noCaps() {
            return OutputHelper.capitalization.noCaps;
        },
    },
    data() {
        return {
            loading: false,
            canvas: null,
        };
    },
    methods: {
        boolToYesNo: OutputHelper.boolToYesNo,
        removeCanvas() {
            showConfirmDialog({
                title: this.trans('pages.canvas_page.delete_canvas.title'),
                content: this.trans('pages.canvas_page.delete_canvas.content'),
                confirm: () => {
                    canvasApi
                        .delete(this.idParam)
                        .then(() => {
                            showInfoMessage(
                                this.trans('pages.canvas_page.canvas_deleted')
                            );
                            this.$router.push('/canvasoverview');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.canvas_page.canvas_delete_error'
                                )
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans(
                    'pages.canvas_page.delete_canvas.confirm'
                ),
                cancelButton: this.trans(
                    'pages.canvas_page.delete_canvas.cancel'
                ),
            });
        },
        load() {
            const canvasId = this.idParam;
            this.loading = true;

            canvasApi.fetch(canvasId).then((response) => {
                const canvas = response.data;

                this.$store.commit(
                    'general/setPageTitle',
                    this.trans('pages.canvas_page.canvas_title', {
                        code: canvas.code,
                        description: canvas.description
                            ? ' - ' + canvas.description
                            : '',
                    }),
                    { root: true }
                );

                this.canvas = canvas;
                this.loading = false;
            });
        },
    },
};
</script>
